import { Box, CircularProgress } from "@mui/material";
import UnauthorizedPage from "../../../components/unauthorizedPage";
import useErpsCliente from "../../../components/erp/useErpsCliente";

// Tela do portal que só existe em alguns tipos de ERP (ex.: NFs só no HubSoft):
// abre se o cliente logado tem algum desses tipos (grupo econômico: algum
// membro). A liberação e a permissão continuam no ClientePermissionRoute.
export default function RotaErpCliente({ tipos = [], children }) {
  const { temTipo, carregado } = useErpsCliente();

  if (!carregado) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress size={100} thickness={2.5} />
      </Box>
    );
  }
  return tipos.some(temTipo) ? children : <UnauthorizedPage />;
}
